export const HIGHCHARTS_TRANSLATIONS = {
  months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  shortMonths: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
  shortWeekdays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  loading: 'Chargement...',
  noData: 'Aucune donnée à afficher',
  printChart: 'Imprimer le graphique',
  downloadPNG: 'Télécharger en PNG',
  downloadJPEG: 'Télécharger en JPEG',
  downloadPDF: 'Télécharger en PDF',
  downloadSVG: 'Télécharger en SVG',
  contextButtonTitle: 'Menu du graphique',
  decimalPoint: ',',
  thousandsSep: ' ',
  numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'],
  rangeSelectorFrom: 'Du',
  rangeSelectorTo: 'Au',
  rangeSelectorZoom: 'Période',
  resetZoom: 'Réinitialiser le zoom',
  resetZoomTitle: 'Réinitialiser le zoom niveau 1:1',
  invalidDate: 'Date invalide',
  viewFullscreen: 'Voir en plein écran',
  exitFullscreen: 'Quitter le plein écran',
  hideData: 'Masquer les données',
  viewData: 'Voir les données en tableau'
};

export const HIGHCHARTS_EXPORTING = {
  sourceWidth: 1200,
  sourceHeight: 800,
  fallbackToExportServer: false
};
